export const types = [
  'Heading1', 
  'Heading2', 
  'Heading3', 
  'Heading4', 
  'Heading5', 
  'Heading6', 
  'BodyLarge',
  'BodyMedium',
  'BodySmall',
] as const;

export const typesMap: {
  [key in typeof types[number]]: string;
} = {
  Heading1: 'heading1',
  Heading2: 'heading2',
  Heading3: 'heading3',
  Heading4: 'heading4',
  Heading5: 'heading5',
  Heading6: 'heading6',
  BodyLarge: 'bodylarge',
  BodyMedium: 'bodymedium',
  BodySmall: 'bodysmall',
};

export const weightNames = [
  'Thin',
  'ExtraLight',
  'Light',
  'Regular',
  'Medium',
  'SemiBold',
  'Bold',
  'ExtraBold',
  'Black',
  'ExtraBlack',
] as const;

export const weightValues = [
  100,
  200,
  300,
  400,
  500,
  600,
  700,
  800,
  900,
  950,
] as const;

export const weights = [
  ...weightNames,
  ...weightValues,
] as const;

export const weightNameMap: {
  [key in typeof weights[number]]: string;
} = {
  Thin: 'thin',
  ExtraLight: 'extralight',
  Light: 'light',
  Regular: 'regular',
  Medium: 'medium',
  SemiBold: 'semibold',
  Bold: 'bold',
  ExtraBold: 'extrabold',
  Black: 'black',
  ExtraBlack: 'extrablack',
  100: 'thin',
  200: 'extralight',
  300: 'light',
  400: 'regular',
  500: 'medium',
  600: 'semibold',
  700: 'bold',
  800: 'extrabold',
  900: 'black',
  950: 'extrablack',
};

export const transforms = [
  'None', 
  'Capitalize', 
  'UpperCase', 
  'LowerCase',
] as const;

export const tansformMap: {
  [key in typeof transforms[number]]: string;
} = {
  None: 'none',
  Capitalize: 'capitalize',
  UpperCase: 'upperCase',
  LowerCase: 'lowerCase',
};